import React from 'react';
import { MapContainer, TileLayer, Marker, Popup, ZoomControl } from 'react-leaflet';
import { Box } from '@bpba/ui-components';
import L from 'leaflet';

// Si ya importaste el CSS globalmente en index.tsx / main.tsx, no hace falta repetirlo acá
// import 'leaflet/dist/leaflet.css';

// Fix para que Leaflet encuentre correctamente los íconos en CRA/Webpack
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

delete (L.Icon.Default.prototype as any)._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

type Props = {
  lat: number;
  lng: number;
  popupText?: string;
  height?: number | string;
  zoom?: number;
};

export const MapaOSM = ({
  lat,
  lng,
  popupText,
  height = 500,
  zoom = 16,
}: Props): JSX.Element => {
  return (
    <Box
      width="100%"
      height={height}
      borderRadius="8px 32px 8px 32px"
      overflow="hidden"
    >
      <MapContainer
        center={[lat, lng]}
        zoom={zoom}
        zoomControl={false}
        style={{ width: '100%', height: '100%' }}
      >
        <TileLayer
          attribution="&copy; OpenStreetMap contributors"
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <ZoomControl position="bottomright" />
        <Marker position={[lat, lng]}>
          {popupText ? <Popup>{popupText}</Popup> : null}
        </Marker>
      </MapContainer>
    </Box>
  );
};